//import Vue from 'vue'

// initial state
const state = {
  darkMode: localStorage.getItem('darkMode') || false,
  shadowDebug: localStorage.getItem('shadowDebug') || false,
}

// getters
const getters = {
  darkMode: state => state.darkMode,
  shadowDebug: state => state.shadowDebug
}

// actions
const actions = {
  setDarkMode({commit}, enabled) {
    console.log('userPreferences setDarkMode', enabled)
    commit('setDarkMode', enabled)
  },
  setShadowDebug({commit}, enabled) {
    console.log('userPreferences setShadowDebug', enabled)
    commit('setShadowDebug', enabled)
  },
}

// mutations
const mutations = {
  setDarkMode(state, enabled) {
    state.darkMode = enabled
    if (enabled) {
      localStorage.setItem('darkMode', enabled)
    } else {
      localStorage.removeItem('darkMode')
    }
  },
  setShadowDebug(state, enabled) {
    state.shadowDebug = enabled
    if (enabled) {
      localStorage.setItem('shadowDebug', enabled)
    } else {
      localStorage.removeItem('shadowDebug')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}